import { AppError } from './app-error.model';
export class NoDataError extends AppError {
  status = 204;
}
